// extracted by mini-css-extract-plugin
export default {"link":"Logo_link__k9LmQ","logo":"Logo_logo__6yrBi"};